(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Toggle the color-inverse class or swap to scrolled color scheme
    const header = document.getElementById('header-component');
    if (!header) return;

    const applyScrolledColorScheme = () => {
      const stickyActive = header.getAttribute('data-sticky-state') === 'active';
      const scrolled = header.getAttribute('data-scroll-direction') === 'up' || header.getAttribute('data-scroll-direction') === 'down';
      const scrolledColorScheme = header.getAttribute('data-scrolled-color-scheme');

      if (scrolledColorScheme) {
        // New behavior: swap to scrolled color scheme
        const shouldApplyScrolledScheme = stickyActive || scrolled;

        if (shouldApplyScrolledScheme) {
          // Store original classes if not already stored
          if (!header.hasAttribute('data-original-color-classes')) {
            const originalClasses = Array.from(header.classList)
              .filter(c => c.startsWith('color-'))
              .join(' ');
            header.setAttribute('data-original-color-classes', originalClasses);
          }

          // Remove all color-* classes
          Array.from(header.classList)
            .filter(c => c.startsWith('color-'))
            .forEach(c => header.classList.remove(c));

          // Apply scrolled scheme
          header.classList.add(scrolledColorScheme);
          header.setAttribute('data-color-scheme-state', 'scrolled');
        } else {
          // Revert to original classes
          const originalClasses = header.getAttribute('data-original-color-classes');
          if (originalClasses) {
            // Remove scrolled scheme
            header.classList.remove(scrolledColorScheme);

            // Restore original classes
            originalClasses.split(' ').forEach(c => {
              if (c) header.classList.add(c);
            });
          }
          header.removeAttribute('data-color-scheme-state');
        }
      } else {
        // Legacy behavior: toggle color-inverse for backwards compatibility
        header.classList.toggle('color-inverse', stickyActive || scrolled);
      }
    };

    // Observe attribute changes on the header to react to sticky/scroll state updates
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && (m.attributeName === 'data-sticky-state' || m.attributeName === 'data-scroll-direction')) {
          requestAnimationFrame(applyScrolledColorScheme);
          break;
        }
      }
    });

    mo.observe(header, { attributes: true });

    // Initial run in case state was set before this script ran
    applyScrolledColorScheme();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !window.DesignMode) return;
  try {
    
  class HeroParallax {
    constructor(element) {
      this.hero = element;
      this.mediaWrapper = this.hero.querySelector('.hero__media-wrapper');
      this.parallaxSpeed = 0.8; // Slower movement speed (0.8 = 80% speed)
      this.init();
    }

    init() {
      if (!this.hero.dataset.parallax) return;

      // Check for reduced motion preference
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleScroll();
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    handleScroll() {
      const rect = this.hero.getBoundingClientRect();
      const scrolled = window.pageYOffset || document.documentElement.scrollTop;
      const heroTop = rect.top + scrolled;
      const heroBottom = heroTop + rect.height;

      // Only apply parallax when hero is in viewport
      if (scrolled > heroTop - window.innerHeight && scrolled < heroBottom) {
        const translateY = (scrolled - heroTop) * this.parallaxSpeed;
        this.hero.style.transform = `translateY(${translateY}px)`;

        // Optional: Also move the media wrapper at a different speed for depth
        if (this.mediaWrapper) {
          const mediaTranslateY = (scrolled - heroTop) * (this.parallaxSpeed * 0.3);
          this.mediaWrapper.style.transform = `translateY(${mediaTranslateY}px)`;
        }
      }
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  // Initialize parallax on all hero sections with data-parallax attribute
  document.addEventListener('DOMContentLoaded', () => {
    const parallaxHeros = document.querySelectorAll('.hero[data-parallax]');
    parallaxHeros.forEach(hero => new HeroParallax(hero));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({behavior: 'instant'});
      }
    }, {once: true});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  // Per-product hover shapes functionality
  document.addEventListener('DOMContentLoaded', function() {
    const productItems = document.querySelectorAll('.resource-list__item--with-hover');

    if (productItems.length === 0) {
      return;
    }

    console.log('Per-product hover shapes initialized:', productItems.length, 'products found');

    // Handle reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const shapes = document.querySelectorAll('.product-shape');
      shapes.forEach(shape => {
        shape.style.animation = 'none';
        shape.style.transition = 'opacity 0.2s ease';
      });
    }

    // Optional: Add intersection observer for performance
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const shapes = entry.target.querySelectorAll('.product-shape');
        if (entry.isIntersecting) {
          shapes.forEach(shape => {
            shape.style.animationPlayState = 'running';
          });
        } else {
          shapes.forEach(shape => {
            shape.style.animationPlayState = 'paused';
          });
        }
      });
    }, { threshold: 0.1 });

    productItems.forEach(item => {
      observer.observe(item);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    
  class SlideshowParallax {
    constructor(element) {
      this.slideshow = element;
      this.parallaxSpeed = 0.8; // Slower movement speed (0.8 = 80% speed)
      this.init();
    }

    init() {
      if (!this.slideshow.dataset.parallax) return;

      // Check for reduced motion preference
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleScroll();
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    handleScroll() {
      const rect = this.slideshow.getBoundingClientRect();
      const scrolled = window.pageYOffset || document.documentElement.scrollTop;
      const slideshowTop = rect.top + scrolled;
      const slideshowBottom = slideshowTop + rect.height;

      // Only apply parallax when slideshow is in viewport
      if (scrolled > slideshowTop - window.innerHeight && scrolled < slideshowBottom) {
        const translateY = (scrolled - slideshowTop) * this.parallaxSpeed;
        this.slideshow.style.transform = `translateY(${translateY}px)`;
      }
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  // Initialize parallax on all slideshow sections with data-parallax attribute
  document.addEventListener('DOMContentLoaded', () => {
    const parallaxSlideshows = document.querySelectorAll('[id^="Slideshow-"][data-parallax]');
    parallaxSlideshows.forEach(slideshow => new SlideshowParallax(slideshow));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["striking-collections"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Initialize carousel functionality for unified striking collections
  const containers = document.querySelectorAll('.striking-products-container[data-carousel="true"]');

  containers.forEach(container => {
    const prevButton = container.querySelector('.striking-carousel-btn--prev');
    const nextButton = container.querySelector('.striking-carousel-btn--next');

    if (!prevButton || !nextButton) return;

    // Get carousel dimensions
    function getScrollAmount() {
      const firstCard = container.querySelector('.striking-product-item');
      if (!firstCard) return 0;

      const cardWidth = firstCard.offsetWidth;
      const gap = parseInt(getComputedStyle(container).getPropertyValue('--product-gap')) || 12;
      // Scroll by 2 cards (full viewport width) on mobile
      return (cardWidth + gap) * 2;
    }

    // Update button states
    function updateButtonStates() {
      const scrollLeft = container.scrollLeft;
      const maxScroll = container.scrollWidth - container.clientWidth;

      prevButton.disabled = scrollLeft <= 0;
      nextButton.disabled = scrollLeft >= maxScroll - 1;
    }

    // Scroll handlers
    prevButton.addEventListener('click', () => {
      container.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', () => {
      container.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    // Update button states on scroll
    container.addEventListener('scroll', updateButtonStates);

    // Initialize button states
    updateButtonStates();

    // Update on window resize
    window.addEventListener('resize', () => {
      setTimeout(updateButtonStates, 100);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
